// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__Zi1o-","type":"styles_type__1N48E","choices":"styles_choices__3MOh8"};